/* État de complétion des tutos, lu depuis le BACK (store onboarding), et non
   plus depuis le localStorage. Source de vérité unique = getStartOnboarding
   (company_onboarding.completed_chapters côté back). */

import store from '@/store';
import {TOUR_TO_CONDITION_KEY} from './catalog';

/** Un tuto est-il complété ? (via son chapitre back, chargé dans le store). */
export function isTourCompleted(tourId: string): boolean {
  const key = TOUR_TO_CONDITION_KEY[tourId];
  if (!key) return false;
  const chapters = store.state.onboarding?.chapters || [];
  return chapters.some(
    (c: any) => c.condition_key === key && c.completed === true,
  );
}

export {};
